import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import { RootState } from "../providers/store";
interface ProtectedRouteProps {
    children: JSX.Element;
    routeId?: number | string ;
}

const ProtectedRoute = ({children, routeId } : ProtectedRouteProps) => {
    const sessionDetails = useSelector((state: RootState) => state?.sessionDetails?.sessionDetails)

    const user = useSelector((state: RootState) => state?.userDetails?.userDetails)

	const location = useLocation();
    // eslint-disable-next-line
    return user?.Token && parseInt(sessionDetails?.RouteId) == routeId ? children : <Navigate to={'/'} state={{from: location}} />
};

export default ProtectedRoute;